import React, { Component, createRef } from 'react';
import { Timeline, Table, Typography, message, Modal, Button, Select, Form, InputNumber, Tooltip, Alert, Col, Row, Space } from 'antd';
import LocationIcon from './../../../../assets/scan_location.png';
import { getOrderPurchaseTrack, internalCompanyList, internalCreateAddress, internalCreateTransfer, internalDetailAddress, internalDetailTransfer } from '../../api';
import { internationalColumns, nationalColumns, nationalColumnsProducts, base_product_list_columns, align } from './logisticsConst';
import { deepClone } from '../../../../util/tool';
import { v4 as uuidv4 } from 'uuid';
import { DoubleRightOutlined } from '@ant-design/icons';
import './index.less';

const { Item } = Timeline;
const { Option } = Select;
const logisticsTitle = { 1: '国际物流', 2: '国内物流', };
export default class LogisticsItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentLogisticsInfo: {},
      currentNationalLogisticsInfo: {},
      isShow: false,
      currentKey: '',
      drawMap: false,
      gpsOptions: {},
      history_list: [],
      isModalVisible: false,
      batch_no: undefined,
      base_product_list: [],
      current_product_list: [],
      harvestAddressModalVisible: false,
      defaultValues: {},
      is_edit: true,
      is_confirm: 0,
      transferModalVisible: false,
      companyList: [],
      currentSVC: {},
      re_edit: false,
      currentTransferId: undefined
    };
    this.product_list_columns = [
      {
        title: '商品名称',
        dataIndex: 'prod_name',
        key: 'prod_name',
        align,
        width: 200,
        render: (text, { product_info = [] }) => {
          return <div className='table-item-div'>
            {product_info.map((item) => <div className='table-item-div-item' key={item.prod_code}>
              <div className='table-item-div-item-ellipsis'><Tooltip title={item.prod_name}>{item.prod_name}</Tooltip></div>
            </div>)}
          </div>;
        }
      },
      {
        title: '商品编码',
        dataIndex: 'prod_code',
        key: 'prod_code',
        align,
        width: 80,
        render: (text, { product_info = [] }) => {
          return <div className='table-item-div'>
            {product_info.map((item) => <div className='table-item-div-item' key={item.prod_code}>{item.prod_code}</div>)}
          </div>;
        }
      },
      {
        title: '规格',
        dataIndex: 'prod_norms',
        key: 'prod_norms',
        align,
        width: 100,
        render: (text, { product_info = [] }) => {
          return <div className='table-item-div'>
            {product_info.map((item) => <div className='table-item-div-item' key={item.prod_code}>{item.prod_norms}</div>)}
          </div>;
        }
      },
      {
        title: '分配数量',
        dataIndex: 'prod_num',
        key: 'prod_num',
        align,
        width: 100,
        render: (text, { product_info: list = [], uuid }) => {
          const { base_product_list = [], is_edit } = this.state;
          const product_info = list.map(item => {
            const { prod_num } = base_product_list.find(s => s.prod_code === item.prod_code);
            return { ...item, max: prod_num };
          });
          return <div className='table-item-div'>
            {product_info.map((item) => <div key={item.prod_code}>
              <Form.Item key={`prod_num_${uuid}_${item.prod_code}`} name={`prod_num_${uuid}_${item.prod_code}`} rules={[{ required: true, message: `请填写分配数量!`, },]}>
                <InputNumber disabled={!is_edit} size='small' controls={false} max={item.max} precision={3} min={0} />
              </Form.Item>
            </div>)}
          </div>;
        }
      },
      {
        title: '收货地址',
        dataIndex: 'address_id',
        key: 'address_id',
        align,
        width: 260,
        render: (text, { uuid }) => {
          const { is_edit } = this.state;
          return <div style={{ padding: 10 }}>
            <Form.Item key={`prod_num_${uuid}`} name={`address_id_${uuid}`} rules={[{ required: true, message: `请填写收货地址!`, },]}>
              <Select disabled={!is_edit} size='small'>{(this.props.addressList || []).map(item => <Option value={item.id} key={item.id}>{item.format_address}</Option>)}</Select>
            </Form.Item>
          </div>;
        }
      },
      {
        title: '操作',
        dataIndex: '',
        key: '',
        align,
        width: 60,
        render: (text, record) => {
          const { is_edit } = this.state;
          return <Button disabled={!is_edit} size='small' type='link' onClick={() => this.deleteItem(record)}>删除</Button>;
        }
      }
    ];
    this.harvestFormRef = createRef();
    this.transferFormRef = createRef();
  }

  componentDidMount() {
    const { batch_no } = this.props;
    this.setState({ batch_no });
    this.requestCompanyList();
  }
  componentWillUnmount() {
    this.setState = () => false;
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { batch_no } = nextProps;
    if (batch_no !== this.props.batch_no) {
      this.setState({ isShow: batch_no === this.props.batch_no, batch_no, currentKey: '' });
    }
  }
  getCurrentOrderPurchaseTrack = async ({ transfer_no, currentNationalLogisticsInfo, currentKey, drawMap, cntr_no }) => {
    const { data: { data, code, msg } } = await getOrderPurchaseTrack({ transfer_no });
    if (+code === 0) {
      const { type } = this.props;
      const { capacityTracks = [], senderLatitude, senderLongitude, receiverLatitude, receiverLongitude } = data || {};
      const [{ gpsTracks = [] }] = capacityTracks;
      const formatGpsTracks = gpsTracks.reduce((Accumulator, Current) => [...Accumulator, [String(Current?.lng), String(Current?.lat),]], []);
      const firstGps = formatGpsTracks?.length ? formatGpsTracks : [[senderLongitude, senderLatitude].filter(item => item)];
      const gpsOptions = { firstGps, lastGps: [[receiverLongitude, receiverLatitude].filter(item => item)], type };
      this.setState({ currentLogisticsInfo: { ...data, cntr_no }, currentNationalLogisticsInfo, isShow: true, currentKey, drawMap, gpsOptions });
      drawMap && this.props.drawAmap(gpsOptions);
    } else {
      message.error(msg);
    }
  }
  renderCurrentOrderPurchaseTrack = (info = {}) => {
    const { type, orderInfo = {} } = this.props;
    const { order_source = '', order_source_desc = '' } = orderInfo;
    const { currentNationalLogisticsInfo = {}, isShow } = this.state;
    const { capacityTracks = [], history_list = [], cntr_no } = info;
    const gpsTracks = capacityTracks?.[0]?.gpsTracks || [];
    const temperature = gpsTracks?.[0]?.temp || '-';
    const currentNationalLogisticsCarList = [currentNationalLogisticsInfo].map((item, index) => ({ ...item, temperature, id: index }));
    const { product_list = [] } = currentNationalLogisticsInfo;
    const productList = product_list.map((item, index) => ({ ...item, index }));
    return <>
      {
        isShow && <>
          <div className='logistics-item-title'>
            <div>
              <span>柜号：{cntr_no}</span>
              {order_source === '转运单' ? <Typography.Link>(由{order_source_desc}转运)</Typography.Link> : null}
            </div>
            <Space>
              {(type === 1) && <>
                {order_source !== '转运单' ?
                  <>
                    {/* <Typography.Link className='logistics-item-history' onClick={() => this.changeReceiver(info)}>换收货方</Typography.Link> */}
                    {/* <Typography.Link className='logistics-item-history' onClick={() => this.changeHarvestAddress(info)}>新增收货地址</Typography.Link> */}
                  </> : null}
                <Typography.Link className='logistics-item-history' onClick={() => this.openHistoryList(history_list)}>历史记录</Typography.Link>
              </>}
            </Space>
          </div>
          {
            (type === 1) && <div className='logistics-item-table'>
              <Table dataSource={productList} rowKey='index' columns={internationalColumns} pagination={false} style={{ marginBottom: '20px' }} />
            </div>
          }
          {
            (type === 2) && <div className='logistics-item-table'>
              <Table dataSource={currentNationalLogisticsCarList} rowKey='id' columns={nationalColumns} pagination={false} style={{ marginBottom: '20px' }} />
              <Table dataSource={productList} rowKey='index' columns={nationalColumnsProducts} pagination={false} />
            </div>
          }
        </>
      }
    </>;
  }
  openHistoryList = (history_list = []) => {
    this.setState({ history_list, isModalVisible: true });
  }
  nationalLogistics = () => {
    const { currentLogistics = [] } = this.props;
    const { currentKey = '' } = this.state;
    return <Timeline>
      {
        currentLogistics.map((item, index) => {
          const { status, lists = [] } = item || {};
          return <Item key={index} className='time-line-item'>
            <div className='time-line-item-title'>{status}</div>
            {
              lists.map((subItem, subIndex) => {
                const { transport_no = '-', card_no = '-', transfer_no, cntr_no = '-' } = subItem || {};
                return <div key={`${transport_no}${subIndex}`} className={['current-logistics', `${subIndex}-${transfer_no}` === currentKey ? 'active' : ''].join(' ')}>
                  <div onClick={() => this.getCurrentOrderPurchaseTrack({ transfer_no, currentNationalLogisticsInfo: subItem, currentKey: `${subIndex}-${transfer_no}`, cntr_no })}>
                    <span className='time-line-item-span'>柜号:{cntr_no}</span>
                    <span className='time-line-item-span'>运单号:{transport_no}</span>
                    <span className='time-line-item-span'>车辆号:{card_no}</span>
                    <img className='logistics-item-image time-line-item-span' src={LocationIcon} alt={LocationIcon} onClick={() => { this.getCurrentOrderPurchaseTrack({ transfer_no, currentNationalLogisticsInfo: subItem, currentKey: `${subIndex}-${transfer_no}`, drawMap: true, cntr_no }); }} />
                  </div>
                </div>;
              })
            }
          </Item>;
        })
      }
    </Timeline>;
  }
  renderLogisticStatus = (info = {}) => {
    const { depart_name, arrive_name, arrive_at, arrive_type, depart_at, depart_type, actual_arrive_at } = info; // actual_arrive_at实际到达时间
    const arrive_at_str = depart_at ? ` ${depart_at}已从${depart_type}-${depart_name}出发 ` : ` 预计从${depart_type}-${depart_name}出发 `;
    const actual_arrive_at_str = actual_arrive_at ? ` ${actual_arrive_at}已到达${arrive_type}-${arrive_name} ` : (arrive_at ? ` 预计${arrive_at}到达${arrive_type}-${arrive_name} ` : ` 预计到达${arrive_type}-${arrive_name} `);
    return <>{depart_name && <div>{arrive_at_str}</div>}{arrive_name && <div>{actual_arrive_at_str}</div>}</>;
  }
  internationalLogistics = () => {
    const { currentLogistics = [] } = this.props;
    const { currentKey = '' } = this.state;
    return <Timeline>
      {
        currentLogistics.map((item, index) => {
          const { status, lists = [] } = item || {};
          return <Item key={index} className='time-line-item'>
            <div className='time-line-item-title'>{status}</div>
            {
              lists.map((subItem, subIndex) => {
                const { card_no = '', transfer_no = '', container_no = '-', trans_type = '', trans_status = '', message = '', cntr_no = '-' } = subItem || {};
                return <div key={`${container_no}${subIndex}`} className={['current-logistics-international current-logistics', `${index}-${subIndex}-${transfer_no}` === currentKey ? 'active' : ''].join(' ')}>
                  {(trans_status === '换运输方式') && (<div><span className='time-line-item-span'> {trans_status} </span></div>)}
                  <div onClick={() => this.getInternationalOrderPurchaseTrack({ transfer_no, currentNationalLogisticsInfo: subItem, currentKey: `${index}-${subIndex}-${transfer_no}` })}>
                    <span className='time-line-item-span'>柜号:{container_no}</span>
                    {(trans_type || card_no) ? <span className='time-line-item-span'>{trans_type}:{card_no || '-'}</span> : null}
                    {message}
                  </div>
                  <div>
                    <img className='logistics-item-image time-line-item-span' src={LocationIcon} alt={LocationIcon} onClick={() => { this.getInternationalOrderPurchaseTrack({ transfer_no, currentNationalLogisticsInfo: subItem, currentKey: `${index}-${subIndex}-${transfer_no}`, drawMap: true, cntr_no }); }} />
                  </div>
                </div>;
              })
            }
          </Item>;
        })
      }
    </Timeline>;
  }
  handleCancel = () => {
    this.setState({ isModalVisible: false, harvestAddressModalVisible: false, is_edit: false, transferModalVisible: false });
  }
  getInternationalOrderPurchaseTrack = async ({ transfer_no, currentNationalLogisticsInfo, currentKey, drawMap, cntr_no }) => {
    console.log('🚀 ~ file: logisticsItem.js:270 ~ LogisticsItem ~ getInternationalOrderPurchaseTrack= ~ drawMap', drawMap);
    const { data: { data, code, msg } } = await getOrderPurchaseTrack({ transfer_no });
    if (+code === 0) {
      if (Reflect.ownKeys(data).length) {
        const { type } = this.props;
        const { capacityTracks = [], senderLatitude, senderLongitude, receiverLatitude, receiverLongitude } = data || {};
        const [{ gpsTracks = [] }] = capacityTracks;
        const formatGpsTracks = gpsTracks.reduce((Accumulator, Current) => [...Accumulator, [String(Current?.lng), String(Current?.lat),]], []);
        const firstGps = formatGpsTracks?.length ? formatGpsTracks : [[senderLongitude, senderLatitude].filter(item => item)];
        const gpsOptions = { firstGps, lastGps: [[receiverLongitude, receiverLatitude].filter(item => item)], type };
        this.setState({ currentLogisticsInfo: currentNationalLogisticsInfo, currentNationalLogisticsInfo, isShow: true, currentKey, drawMap, gpsOptions });
        // this.setState({ currentLogisticsInfo: { ...data, cntr_no }, currentNationalLogisticsInfo, isShow: true, currentKey, drawMap, gpsOptions });
        drawMap && this.props.drawAmap(gpsOptions);
      } else {
        this.setState({ currentLogisticsInfo: currentNationalLogisticsInfo, currentNationalLogisticsInfo, currentKey, isShow: true, cntr_no });
      }
    } else {
      message.error(msg);
    }
  }
  createDefaultHarvestValues = (list = []) => {
    const defaultValues = {};
    for (let item of list) {
      const { uuid, product_info = [] } = item;
      defaultValues[`address_id_${uuid}`] = item?.address_id;
      for (let sItem of product_info) {
        defaultValues[`prod_num_${uuid}_${sItem.prod_code}`] = +sItem?.prod_num || '';
      }
    }
    return defaultValues;
  }
  changeHarvestAddress = async info => {
    const { product_list = [] } = info;
    const base_product_list = deepClone(product_list);
    const { currentLogisticsInfo = {} } = this.state;
    const { cntr_no } = currentLogisticsInfo;
    const { batch_no, orderNo } = this.props;
    const { data: { code, msg, data = {} } } = await internalDetailAddress({ container_no: cntr_no, order_no: orderNo, batch_no });
    if (+code === 0) {
      const { is_edit, is_confirm, list = [] } = data;
      const current_product_list = list.map((item) => ({ ...item, uuid: uuidv4() }));
      const defaultValues = this.createDefaultHarvestValues(current_product_list);
      if (is_confirm) {
        message.error('国内收货信息已确认，不可再增加收货地址');
      } else if (!is_edit) {
        message.error('该柜已换收货方，不可再增加收货地址');
      }
      this.setState({ harvestAddressModalVisible: true, base_product_list, defaultValues, is_edit: is_confirm ? false : is_edit, current_product_list });
    } else {
      message.error(msg);
    }
  }
  addCurrentProduct = () => {
    const { current_product_list = [] } = this.state;
    const new_current_product_list = [...current_product_list, this.createBaseItem()];
    this.setState({ current_product_list: new_current_product_list });
  }
  createBaseItem = () => {
    const { base_product_list = [] } = this.state;
    return { address_id: '', addressName: '', product_info: deepClone(base_product_list), type: 'new', status: 1, uuid: uuidv4() };
  }
  deleteItem = (record) => {
    const { uuid } = record;
    const { current_product_list = [] } = this.state;
    const new_current_product_list = current_product_list.filter(item => !((item.type === 'new') && (uuid === item.uuid))).map(item => ({ ...item, status: !item.type && (uuid === item.uuid) ? 0 : item.status }));
    this.setState({ current_product_list: new_current_product_list });
  }
  onFinish = () => {
    const values = this.harvestFormRef?.getFieldsValue() || {};
    const { current_product_list = [], currentLogisticsInfo = {} } = this.state;
    const { cntr_no } = currentLogisticsInfo;
    const { addressList = [], batch_no, orderNo } = this.props;

    const address_lists = current_product_list.map((item) => {
      const { product_info: list = [], status, uuid } = item;
      const address_id = values[`address_id_${item.uuid}`] || item.address_id;
      const addressItem = addressList.find(a => String(a.id) === String(address_id));
      const product_info = list.map(subItem => ({ ...subItem, prod_num: values[`prod_num_${uuid}_${subItem.prod_code}`] }));
      return +status === 0 ? item : { ...addressItem, id: '', ...item, address_id, product_info };
    });
    this.save({ address_lists, container_no: cntr_no, order_no: orderNo, batch_no });
  }
  save = async params => {
    const { data: { code, msg } } = await internalCreateAddress(params);
    if (+code === 0) {
      message.success(msg, 1, this.handleCancel);
    } else {
      message.error(msg);
    }
  }
  onFinishFailed = () => {
    message.error('信息未填写完整!');
  };
  requestCompanyList = async () => {
    const { data: { data = [], code, msg } } = await internalCompanyList();
    if (+code === 0) {
      // const companyId = localStorage.getItem('companyId');
      // const companyList = (data || []).map(item => ({ ...item, disabled: String(item.id) === String(companyId) }));
      this.setState({ companyList: data });
    } else {
      message.error(msg);
    }
  }
  createDefaultTransferValues = (list = []) => list.reduce((pre, next) => ({ ...pre, [`prod_num_${next.prod_code}`]: +next.prod_num || '' }), {});
  changeReceiver = async info => {
    const { product_list = [] } = info;
    const base_product_list = deepClone(product_list);
    const { currentLogisticsInfo = {}, companyList = [] } = this.state;
    const { cntr_no } = currentLogisticsInfo;
    const { batch_no, orderNo } = this.props;
    const { data: { code, msg, data = {} } } = await internalDetailTransfer({ container_no: cntr_no, order_no: orderNo, batch_no });
    if (+code === 0) {
      const { is_edit, is_confirm, data: { company_id = '', product_info = [], status = 0, id: currentTransferId = '' } = { company_id: '', product_info: [], status: 0, id: undefined } } = data;
      const re_edit = !(is_edit === 0 && status === 0); //不展示按钮
      const current_list = product_info.map((item) => ({ ...item, uuid: uuidv4() }));
      const currentSVC = companyList.find(item => String(item.id) === String(company_id)) || {};
      const defaultValues = this.createDefaultTransferValues(current_list);
      const edit = is_edit && !status;
      if (is_confirm) {
        message.error('国内收货方信息已确认，不可换收货方');
      } else if (!is_edit) {
        message.error('该柜已增加收货地址,不可换收货方');
      }
      this.setState({ transferModalVisible: true, defaultValues: { ...defaultValues, company_id }, is_edit: edit, is_confirm, currentSVC, base_product_list, re_edit, currentTransferId }, () => {
        // this.transferFormRef.setFieldsValue({ ...defaultValues, company_id });
      });
    } else {
      message.error(msg);
    }
  }
  onTransferFinish = () => {
    const values = this.transferFormRef?.getFieldsValue() || {};
    const { currentLogisticsInfo = {}, currentSVC, base_product_list = [] } = this.state;
    const { cntr_no: container_no } = currentLogisticsInfo;
    const { batch_no, orderNo: order_no } = this.props;
    const product_info = base_product_list.map(item => ({ prod_code: item.prod_code, prod_num: values[`prod_num_${item.prod_code}`] }));
    this.transferSave({ order_no, batch_no, container_no, company_id: currentSVC?.id || '', product_info });
  }
  transferSave = async params => {
    const { data: { code, msg } } = await internalCreateTransfer(params);
    if (+code === 0) {
      message.success(msg, 1, this.handleCancel);
    } else {
      message.error(msg);
    }
  }
  onTransferFinishFailed = () => {
    message.error('信息未填写完整!');
  }
  transferCompanyChange = e => {
    const { companyList = [] } = this.state;
    const currentSVC = companyList.find(item => String(item.id) === String(e));
    this.setState({ currentSVC });
  }
  cancelTransfer = async () => {
    const { is_edit, currentTransferId } = this.state;
    const { data: { code, msg } } = await internalCreateTransfer({ id: currentTransferId, status: 0 });
    if (+code === 0) {
      message.success(msg, 1);
      const timer = setTimeout(() => {
        this.setState({ is_edit: !is_edit, defaultValues: {}, currentSVC: {} });
        this.transferFormRef.resetFields();
        clearTimeout(timer);
      });
    } else {
      message.error(msg);
    }
  }
  render() {
    const { currentLogisticsInfo, isModalVisible, history_list = [], harvestAddressModalVisible, base_product_list = [], current_product_list = [], defaultValues = {}, is_edit, transferModalVisible, companyList = [], currentSVC = {}, re_edit, is_confirm } = this.state;
    const historyList = history_list.map((item, index) => ({ ...item, currentKey: index }));
    const { type, orderInfo = {} } = this.props;
    const { purchaseName = '', userName = '', address = '' } = orderInfo;
    const title = logisticsTitle[+type];
    const current_product_list_filter = current_product_list.filter(item => item.status);
    const transfer_base_product_list_columns = [
      ...base_product_list_columns.slice(0, -1),
      {
        title: '总数量',
        dataIndex: 'prod_num',
        key: 'prod_num',
        align,
        width: 120
      },
      {
        title: '转运数量',
        dataIndex: 'prod_num',
        key: 'prod_num',
        align,
        width: 120,
        render: (text, { prod_code, prod_num }) => {
          const { is_edit } = this.state;
          return <Form.Item name={`prod_num_${prod_code}`} rules={[{ required: true, message: `请填写分配数量!`, },]}>
            <InputNumber disabled={!is_edit} size='small' controls={false} max={prod_num} precision={3} min={0} />
          </Form.Item>;
        }
      }
    ];
    return (
      <div className='logistics-item-container'>
        <div className='logistics-item-left'>
          <div className='logistics-item-title'><span className='logistics-item-span'>{title}</span></div>
          <div className='logistics-item-left-time-line'>{type === 1 ? this.internationalLogistics() : this.nationalLogistics()}</div>
        </div>
        <div className='logistics-item-right'>{this.renderCurrentOrderPurchaseTrack(currentLogisticsInfo)}</div>
        {/* /历史记录 */}
        <Modal className='logistics-modal' title="历史记录" width='840px' open={isModalVisible} footer={null} destroyOnClose onCancel={this.handleCancel}>
          <div className='logistics-info-content'>
            {<Timeline>
              {
                historyList.map((item, index) => {
                  const { created_at, message } = item;
                  return <Item key={index} className='time-line-item'>
                    <div className='time-line-item-title'>{created_at} {message}</div>
                  </Item>;
                })
              }
            </Timeline>}
          </div>
          {/* <Table dataSource={historyList} rowKey='currentKey' columns={historyColumns} pagination={false} style={{ marginBottom: '20px' }} /> */}
        </Modal>
        {/* 变更收货地址 */}
        <Modal className='logistics-modal' title="" width='80%' open={harvestAddressModalVisible} footer={null} destroyOnClose centered onCancel={this.handleCancel}>
          <>
            <div className='logistics-container-modal-content-title'><span className='modal-content-title-span'>可发货商品</span></div>
            <Table bordered dataSource={base_product_list} columns={base_product_list_columns} rowKey='prod_code' pagination={false} style={{ marginBottom: '20px' }}></Table>
            <div className='logistics-container-modal-content-title'>
              <span className='modal-content-title-span'>各收货地址商品分配</span>
              <Typography.Link disabled={!is_edit} onClick={() => this.addCurrentProduct()}>增加收货地址</Typography.Link >
            </div>
            <Form ref={el => this.harvestFormRef = el} onFinish={this.onFinish} onFinishFailed={this.onFinishFailed} initialValues={defaultValues}>
              <Table bordered dataSource={current_product_list_filter} columns={this.product_list_columns} rowKey='uuid' pagination={false} style={{ marginBottom: '20px' }}></Table>
              <div className='logistics-modal-btn'>
                {current_product_list_filter?.length ? <Form.Item><Button disabled={!is_edit} size='small' type="primary" htmlType="submit">提交</Button></Form.Item> : <Form.Item><Button size='small' disabled={!is_edit} type="primary" onClick={this.onFinish}>提交</Button></Form.Item>}
                <Form.Item><Button style={{ marginLeft: 30 }} size='small' type="default" onClick={this.handleCancel}>取消</Button></Form.Item>
              </div>
            </Form>
          </>
        </Modal>
        {/* 转运 */}
        <Modal className='logistics-modal' title="换收货方" width='800px' open={transferModalVisible} footer={null} destroyOnClose centered onCancel={this.handleCancel}>
          <>
            <Alert description="请填写需转运的商品数量及转运方，确认后，将由供应方确认新收货方信息进行国内发货" type="warning" showIcon />
            <div className='logistics-container-modal-content-title'><span className='modal-content-title-span'>转运商品</span></div>
            <Form ref={el => this.transferFormRef = el} onFinish={this.onTransferFinish} onFinishFailed={this.onTransferFinishFailed} initialValues={defaultValues}>
              <Table bordered dataSource={base_product_list} columns={transfer_base_product_list_columns} rowKey='prod_code' pagination={false} style={{ marginBottom: '20px' }}></Table>
              <div className='logistics-modal-transfer'>
                <div className='logistics-modal-transfer-aside'>
                  <div>
                    <div className='logistics-modal-transfer-aside-title'>当前收货方</div>
                    <Row><Col span={6}>公司名称：</Col><Col span={14}>{purchaseName}</Col></Row>
                  </div>
                  <div><Row><Col span={6}>SVC区域：</Col><Col span={14}>{userName}</Col></Row></div>
                  <div><Row><Col span={6}>收货地址：</Col><Col span={14}>{address}</Col></Row></div>
                </div>
                <div className='logistics-modal-transfer-center'>
                  <div>转运至</div>
                  <div><DoubleRightOutlined /></div>
                </div>
                <div className='logistics-modal-transfer-aside'>
                  <div>
                    <div className='logistics-modal-transfer-aside-title'>转运收货方</div>
                    <Form.Item label='公司名称' name='company_id' rules={[{ required: true, message: `请填写公司名称!`, },]}>
                      <Select
                        className='logistics-modal-transfer-select'
                        size='small'
                        showSearch
                        placeholder=""
                        optionFilterProp="children"
                        filterOption={(input, option) => option.children.includes(input)}
                        onChange={this.transferCompanyChange}
                        disabled={!is_edit}
                      >
                        {(companyList || []).map(item => <Option key={item.id} value={item.id} disabled={item.disabled}>{item.name}</Option>)}
                      </Select>
                    </Form.Item>
                  </div>
                  <div><Row><Col span={6}>SVC区域：</Col><Col span={14}>{currentSVC?.svc_name}</Col></Row></div>
                </div>
              </div>
              <div className='logistics-modal-btn'>
                {is_confirm ? null :
                  <>{re_edit ? <>{is_edit ? <Form.Item><Button disabled={!is_edit} size='small' type="primary" htmlType="submit">确认</Button></Form.Item> :
                    <Form.Item><Button size='small' htmlType="button" onClick={this.cancelTransfer}>取消换收货方</Button></Form.Item>}</> : null}</>
                }
              </div>
            </Form>
          </>
        </Modal>
      </div>
    );
  }
}
